import { forwardRef } from 'react';

import { IconProps } from './icons.types';

export const NestIndicatorIcon = forwardRef<SVGSVGElement, IconProps>(function NestIndicatorIcon(
  { color = '#EBE9F5', height = 16, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 17"
      fill="none"
      {...props}
    >
      <path d="M1 0V12C1 14.2091 2.79086 16 5 16H13" stroke={color || 'currentColor'} />
    </svg>
  );
});
